<template lang="pug">
.subscribe-connect-modal
  y-dialog(v-model="dialog" persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600px")
    v-card(min-height="80vh")
      v-card-title.px-4
        v-layout
          eva-icon.mr-4(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" @click="dialog = false")
          .h6.textColor--text {{ $t('connect_subscription') }}
      v-card-text.px-4
        y-stepper.mb-8(v-if="step < 4" :currentStep="step" :steps="steps")
        v-window(v-model="step" touchless)
          v-window-item(:value="0")
            v-layout.pa-6(v-if="isFetchingPlanGroup")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .plans(v-else)
              v-card.px-4.mb-4.pb-1(v-for="(plan, index) in plans" outlined :ripple="false" :key="plan.value" :style="plan.selected ? 'border: 2px solid var(--v-textColorAccent)' : 'border: 2px solid var(--v-basic300)'" :color="currentPlan(plan) ? $vuetify.theme.themes[$theme].dangerT08: $vuetify.theme.themes[$theme].basic600T08")
                .pt-2.cursor-pointer(@click="selectPlan(plan)")
                  v-row
                    v-col
                      v-layout
                        .h5.textColor--text {{ plan.name }}
                        v-avatar.my-auto.ml-2(v-if="plan.selected" :color='$vuetify.theme.themes[$theme].textColorAccent' size=20)
                          eva-icon(name="checkmark-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="16" height="16" style="margin-top:2px;")
                      div.danger500--text(v-if="currentPlan(plan)") (Current Plan)
                    v-col
                      .h6.textColorHint--text.text-decoration-line-through.text-right(v-if="plan.slash_price[form.commitment] && plan.slash_price[form.commitment][$currency.code]") {{ plan.slash_price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
                      .h4.textColor--text.text-right(v-if="plan.price[form.commitment]") {{ plan.price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
                  v-row.mb-3(no-gutters)
                    v-col
                      .p1.primary500--text(v-for="feature in plan.detail.features") {{ feature }}
                    v-col
                      .p2.primary400--text.text-right {{ $currency.symbol }} per {{ form.commitment === 'yearly' ? 'year' : 'month' }}
                      .p2.primary400--text.text-right(v-if="form.commitment === 'monthly' && plan.value !== 4")

          v-window-item(:value="1")
            .h5.textColor--text.text-center {{ $t('step_1.select_payment_method') }}
            v-card.mt-8(flat outlined style="border:1px solid var(--v-basic300);")
              v-radio-group.mt-n1(v-model="selectedPaymentMethod" hide-details)
                v-layout(style="cursor: pointer" @click="selectedPaymentMethod = 'card'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text {{ $t('step_1.card') }}
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="card" readonly)
            v-card.pa-4.mt-8(v-if="selectedPaymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="selectedPaymentMethod === 'card'" @change="form.card = $event.id")

          v-window-item.text-center(:value="2")
            v-layout.pa-6(v-if="isFetchingQuotation")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            template(v-else-if="quotation")
              template(v-if="quotation.void")
                .h6.mt-12.danger500--text {{ $t('no_change_subscription') }}
              template(v-else-if="hasPendingBills")
                .h3.mt-12.danger500--text {{ $t('step_2.pending_payment') }}
                .h6.mt-6.textColor--text {{ $tc('step_2.you_have', quotation.pending_bills.length, { count: quotation.pending_bills.length }) }} {{ $t('step_2.please_take') }}
                v-btn.mt-4(color="danger500" dark @click="clickPayBill" depressed height=32 )
                  .button-AA-medium.basic100--text {{ $t('step_2.pay_now') }}
              template(v-else)
                .h5.textColor--text.text-center {{ $t('step_2.confirm_subscribe') }}
                .h3.mt-6.textColor--text {{ selectedPlan.name }} {{ $t('step_2.plan') }}
                .h1.text-center.my-8 {{ quotation.total_amount | displayPrice($currency) }}
                .s1.primary500--text {{ $t('step_2.next_billing_amount', { amount: $options.filters.displayPrice(quotation.next_bill_amount, $currency) }) }}
                .s1.primary500--text {{ $t('step_2.next_billing_date', { date: $options.filters.displayDate(quotation.end_date) }) }}
            template(v-else-if="selectedPlan")
              .h5.textColor--text.text-center {{ $t('step_2.confirm_subscribe') }}
              .h3.mt-6.textColor--text {{ selectedPlan.name }} {{ $t('step_2.plan') }}
              .h1.text-center.my-8 {{ selectedPlan.price[form.commitment][$currency.code] | displayPrice($currency) }}

          v-window-item(:value="3")
            .h5.textColor--text.mb-8.text-center {{ $t('step_3.subscribe_successful') }}
            v-container.text-center
              .p1.primary400--text {{ $t('step_3.thanks') }}
              .p1.primary400--text.mt-4 {{ $t('step_3.thanks_2') }}
              v-btn.mt-4(color="info500" dark @click="closeDialog" depressed height=32 )
                .button-AA-medium.basic100--text {{ $t('step_3.finish_button') }}

          v-window-item(:value="4")
            .h5.textColor--text.mb-8.text-center {{ $t('step_4.payment_failed') }}
            v-container.text-center
              .p1.primary400--text {{ $t('step_4.try_again') }}

      v-divider.basic300(v-if="step == 0")
      v-card-actions.basic200.px-4(v-if="step == 0 && selectedPlan")
        v-col.pa-0
          .s2.primary400--text {{ $t('card_actions.selected_plan') }}
          v-layout
            .p2.textColor--text {{ selectedPlan.name }} ({{ form.commitment }} {{ $t('card_actions.contract') }})
            v-spacer
            .p2.textColor--text(v-if="selectedPlan.price[form.commitment]") {{ $currency.symbol }} {{ selectedPlan.price[form.commitment][$currency.code] | displayNumberPrice($currency) }}
      v-divider.basic400(v-if="step == 0")

      v-card-actions.pr-4(v-if="authMember.id === company.primary_owner" :class="step == 0 ? 'basic200' : ''")
        template(v-if="step < 3")
          v-spacer
          v-btn(v-if="step === 0" color='white' text @click="dialog = false")
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn(v-else color='white' text @click="step--")
            .button-Aa-medium.primary400--text {{ $t('back') }}
          v-btn(v-if="step === 0" color="info500" @click="nextStep" depressed height=32 :disabled="!selectedPlan")
            .button-AA-medium.basic100--text {{ $t('next') }}
          v-btn(v-else-if="step == 1" color="info500" @click="nextStep" depressed height=32 :disabled="((company.currency.currency_code === 'MYR' && !fpxBankCode) || selectedPaymentMethod !== 'fpx') && !form.card")
            .button-AA-medium.basic100--text {{ $t('next') }}
          v-btn(v-else color="info500" @click="nextStep" depressed height=32 :loading="isLoading" :dark="!disableProceedPayment" :disabled="disableProceedPayment")
            .button-AA-medium.basic100--text {{ step === 2 ? $t('card_actions.confirm_pay') : $t('card_actions.next') }}
      v-card-actions(v-else)
        v-spacer
        v-btn(v-if="company.status === 'Trial'" color='white' text @click="dialog = false")
          .button-Aa-medium.primary400--text {{ $t('close') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import CardList from '@/components/billing/CardList.vue'
import Cookies from 'js-cookie'

export default {
  name: "EditSubscriptionConnectModal",
  components: { CardList },
  props: ['open', 'company', 'paymentCallback'],
  data: (v) => ({
    isFetchingPlanGroup: false,
    isFetchingQuotation: false,
    step: 0,
    planGroup: null,
    plans: [
      { name: 'Free', value: 1, detail: { features: [ '1 User', '5 Segments', '5 System Tabs', '5 Personal Tabs', '50 Message Templates'] }, selected: false, plan: 'YC_FREE_PLAN', contract: {} },
      { name: 'Basic', value: 2, detail: { features: [ '5 Users', 'Unlimited Segments', 'Unlimited System Tabs', 'Unlimited Personal Tabs', 'Unlimited Message Templates', '+1000 Integrations and more'] }, selected: false, plan: 'YC_BASIC_PLAN', contract: {} }
    ],
    contracts: [],
    form: {
      company: v.company.id,
      plan: null,
      contract: null,
      commitment: 'monthly',
      billing_cycle: 'yearly',
      card: null
    },
    isLoading: false,
    selectedPaymentMethod: null,
    fpxBankCode: null,
    quotation: null,
    steps: [
      { title: 'Select plan', hidden: false, secondaryButton: 'Back', primaryButton: 'Next' },
      { title: 'Payment', hidden: false, secondaryButton: 'Back', primaryButton: 'Next' },
      { title: 'Confirmation', hidden: false, secondaryButton: 'Back', primaryButton: 'Confirm' },
      { title: 'Subscription Successful!', hidden: true, primaryButton: null },
      { title: 'Payment Unsuccessful', hidden: true, primaryButton: null }
    ],
    selectedPlan: null
  }),
  computed: {
    ...mapState('subscriptions', ['genesData', 'connectSubscription']),
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    hasPendingBills () {
      if (this.quotation && this.quotation.pending_bills.length > 0) {
        return true
      }
      return false
    },
    disableProceedPayment () {
      if (this.connectSubscription.value) {
        if (!this.quotation) {
          return true
        }
        if (this.quotation.void) {
          return true
        }
      }
      if (this.hasPendingBills) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchCompany()
    this.fetchPlanGroup()

    if (this.paymentCallback) {
      if (this.paymentCallback.success) {
        this.step = 4
      } else {
        this.step = 5
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    fetchCompany () {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios.get(`/companies/${this.company.id}/`)
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
      } else {
        this.$axios.get(`/companies/${this.$subdomain}/`, { params: { use_slug: 'true' } })
        .then(resp => {
          this.updateCompany(resp.data)
        })
        .catch(() => {})
      }
    },
    fetchPlanGroup () {
      this.isFetchingPlanGroup = true
      this.$axios.get(`/subscription/plan_groups/YCONNECT`)
      .then(resp => {
        this.planGroup = resp.data
        this.plans.forEach(o => {
          const plan = resp.data.plans.find(f => f.code === o.plan)
          if (plan) {
            const monthly = plan.contracts.find(f => f.billing_cycle === 'monthly')
            const price = {
              monthly: monthly?.prices || null,
            }
            const slash_price = {
              monthly: monthly?.compare_at_prices && Object.keys(monthly?.compare_at_prices).length > 0 ?  monthly.compare_at_prices : null,
            }
            this.$set(o, 'price', price)
            this.$set(o, 'slash_price', slash_price)
            this.$set(o, 'contract', monthly)
          }
        })
        this.checkCurrentPlan()
      })
      .catch(() => {})
      .finally(() => {
        this.isFetchingPlanGroup = false
      })
    },
    checkCurrentPlan () {
      this.plans.forEach(plan => {
        if (this.currentPlan(plan)) {
          this.selectPlan(plan)
        }
      })
    },
    currentPlan(plan) {
      return this.connectSubscription.data.plan === plan.plan
    },
    selectPlan(plan) {
      this.plans.forEach(p => {
        if (p.value === plan.value) {
          p.selected = true
          this.selectedPlan = p
        } else {
          p.selected = false
        }
      })
    },
    fetchQuotation() {
      this.isFetchingQuotation = true
      let contract = this.planGroup.plans.filter(p => p.code === this.selectedPlan.plan)[0].contracts.filter(p => p.code === `${this.selectedPlan.plan}${this.form.commitment === 'monthly' ? '_MM' : this.form.billing_cycle === 'monthly' ? '_YM' : '_YY'}`)[0]
      if (!contract) {
        contract = this.planGroup.plans.filter(p => p.code === this.selectedPlan.plan)[0].contracts.filter(p => p.code === `${this.selectedPlan.plan}`)[0]
      }
      if (!contract) {
        this.showMessage(['error', this.$t('invalid_plan')])
        return
      }
      const data = {
        contract: contract.code,
      }
      this.$axios.post(`/subscription/subscriptions/${this.connectSubscription.data.id}/quotation`, data)
      .then(resp => {
        this.quotation = resp.data
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_subscribe_try_again_contact_us')])
      })
      .finally(() => {
        this.isFetchingQuotation = false
      })
    },
    selectContract(contract) {
      this.contracts.forEach(c => {
        if (c.data.code === contract.data.code) {
          c.selected = true
          this.selectedContract = c
        } else {
          c.selected = false
        }
      })
    },
    previousStep () {
      if (this.step === 0) {
        this.dialog = false
      } else {
        this.step--
      }
    },
    nextStep () {
      if (this.step === this.steps.length - 1) {
        return
      }

      if (this.step === 1) {
        if (!this.selectedPaymentMethod) {
          this.showMessage(['error', this.$t('please_select_payment_method')])
          return
        }
      }

      if (this.connectSubscription.value) {
        if (this.step === 1) {
          this.fetchQuotation()
        }
        if (this.step === 2) {
          this.isLoading = true
          this.$axios.post(`/subscription/subscriptions/${this.connectSubscription.data.id}/change`, this.quotation)
            .then(resp => {
              if (this.selectedPaymentMethod === 'card') {
                this.subscribeByCard(resp.data)
              }
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
              this.isLoading = false
            })
        } else {
          this.step++
        }
      } else {
        if (this.step === 2) {
          this.subscribeConnect()
        } else {
          this.step++
        }
      }
    },
    subscribeConnect () {
      this.isLoading = true
      const data = {
        company: this.company.id,
        contract: this.selectedPlan.contract.code,
        card: this.form.card,
      }
      this.$axios.post(`/subscription/subscriptions/`, data)
      .then(resp => {
        this.$axios.post(`/subscription/bills/${resp.data.bill}/charge_card/`, data)
        .then(() => {
          this.$emit('subscribed')
          this.fetchCompany()
          this.step++
        })
        .catch(() => {
          this.message = 'Subscription successful. Please complete the payment to avoid termination.'
        })
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
        this.isLoading = false
      })
    },
    subscribeByCard (data) {
      this.isLoading = true
      this.form.contracts = this.quotation.contracts
      this.form.fbq = {
        cookies: Cookies.get(),
        user_agent: navigator.userAgent
      }
      this.$axios.post(`/subscription/bills/${data.bill}/charge_card/`, this.form)
        .then(() => {
          this.$emit('subscribed')
          this.fetchCompany()
          this.step++
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickPayBill () {
      if (this.quotation.pending_bills.length > 0) {
        this.$router.push(`/admin/billing/bills/${this.quotation.pending_bills[0]}`)
      }
    },
    closeDialog () {
      this.$emit('setgene')
      this.dialog = false
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.v-card.payment-method-selected {
  border-color: #D11184;
}

.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>

<i18n>
{
  "en": {
    "card_actions": {
      "back": "Back",
      "cancel": "Cancel",
      "close": "Close",
      "confirm_pay": "Confirm and pay",
      "contract": "contract",
      "forms": "forms ({text} add-ons)",
      "manage_account": "Manage your account or select add-ons to fit this plan",
      "next": "Next",
      "salespersons": "salespersons ({text} add-ons)",
      "selected_plan": "Selected plan:",
      "service_fee": "Service Fee (% of transaction)",
      "subscrbe_later": "Subscribe later"
    },
    "step_0": {
      "addons": "Add-ons",
      "active_addons": "Active add-ons",
      "boost_sales": "( Recommended to Boost your Sales )",
      "current_account": "Your current account",
      "current_plan": "Current Plan",
      "each_month": "each/month",
      "each_year": "each/year",
      "follow_up_system": "Follow-up System",
      "agent_commission_system": "Agent Commission System",
      "product_bundle_offer": "Product Bundle Offer",
      "form": "Form",
      "forms": "published forms",
      "manage_button": "Manage",
      "members": "active salespersons / agents",
      "monthly_contract": "Monthly contract",
      "monthly_offer": "Grab discount now!",
      "salesperson": "Salesperson",
      "yearly_contract": "Yearly contract",
      "yearly_offer": "2 Months Free",
      "subscribed_addons": "Subscribed add-ons",
      "form_addons": "+ {count} form (active until {date}) | + {count} forms (active until {date})",
      "member_addons": "+ {count} member (active until {date}) | + {count} members (active until {date})"
    },
    "step_1": {
      "annual_billing": "For annual billing only",
      "card": "Credit or debit card",
      "choose_bank": "Choose bank for payment",
      "online": "Online banking",
      "select_payment_method": "Select payment method",
      "yearly_contract": "For yearly contract only"
    },
    "step_2": {
      "confirm_subscribe": "Confirm your subscription",
      "extra_form": "extra form | extra forms",
      "extra_member": "extra member | extra members",
      "plan": "Plan",
      "price_month": "per month with monthly contract",
      "price_year": "per {text} with yearly contract",
      "transacton": "of transaction",
      "current_billing_amount": "Current billing amount: {amount}",
      "next_billing_amount": "Next billing amount: {amount}",
      "next_billing_date": "Next billing date: {date}",
      "pending_payment": "Pending payment",
      "pay_now": "Pay now",
      "you_have": "You have {count} pending payment. | You have {count} pending payments.",
      "please_take": "Please take care of any outstanding payments before changing subscription"
    },
    "step_3": {
      "finish_button": "FINISH",
      "subscribe_successful": "Subscription successful!",
      "thanks": "Thank you for giving us the opportunity to help you grow further and bigger.",
      "thanks_2": "Let’s do this together."
    },
    "step_4": {
      "payment_failed": "Payment failed",
      "retry_button": "Retry Payment",
      "try_again": "The payment did not go through, please try again."
    },
    "connect_subscription": "Connect Subscription"
  },
  "id": {
    "card_actions": {
      "back": "Kembali",
      "cancel": "Batal",
      "close": "Tutup",
      "confirm_pay": "Mengkonfirmasi dan membayar",
      "contract": "kontrak",
      "forms": "form (pengaya {text})",
      "manage_account": "Kelola akun kamu atau pilih add-on agar sesuai dengan paket ini",
      "next": "Lanjut",
      "salespersons": "wiraniaga (pengaya {text})",
      "selected_plan": "Paket yang dipilih:",
      "service_fee": "Biaya Layanan (% dari transaksi)",
      "subscrbe_later": "Berlangganan nanti"
    },
    "step_0": {
      "addons": "Add-on",
      "active_addons": "Add-ons aktif",
      "boost_sales": "(Disarankan untuk Meningkatkan Penjualan kamu)",
      "current_account": "Akun kamu saat ini",
      "current_plan": "Rencana saat ini",
      "each_month": "setiap bulan",
      "each_year": "setiap tahun",
      "follow_up_system": "Sistem tindak lanjut",
      "agent_commission_system": "Sistem Komisi Agen",
      "product_bundle_offer": "Penawaran Paket Produk",
      "form": "Form",
      "forms": "form yang diterbitkan",
      "manage_button": "Mengelola",
      "members": "penjual/agen aktif",
      "monthly_contract": "paket bulanan",
      "monthly_offer": "Dapatkan diskon sekarang!",
      "salesperson": "Salesperson",
      "yearly_contract": "Paket tahunan",
      "yearly_offer": "2 Bulan Gratis",
      "subscribed_addons": "Pengaya berlangganan",
      "form_addons": "+ {count} form (aktif sampai {date}) | + {count} forms (aktif sampai {date})",
      "member_addons": "+ {count} anggota (aktif sampai {date}) | + {count} anggota (aktif sampai {date})"
    },
    "step_1": {
      "annual_billing": "Hanya untuk tagihan tahunan",
      "card": "Kartu kredit atau debit",
      "choose_bank": "Pilih bank untuk pembayaran",
      "online": "Perbankan online",
      "select_payment_method": "Pilih metode pembayaran",
      "yearly_contract": "Hanya untuk paket tahunan"
    },
    "step_2": {
      "confirm_subscribe": "Konfirmasi langganan kamu",
      "extra_form": "form tambahan | form tambahan",
      "extra_member": "anggota tambahan | anggota tambahan",
      "plan": "Plan",
      "price_month": "per bulan dengan paket bulanan",
      "price_year": "per {text} dengan paket tahunan",
      "transacton": "transaksi",
      "next_billing_date": "Tanggal tagihan berikutnya: {date}",
      "pending_payment": "Pembayaran tertunda",
      "pay_now": "Bayar sekarang",
      "you_have": "Anda memiliki {count} pembayaran yang tertunda. | kamu memiliki {count} pembayaran yang tertunda.",
      "please_take": "Harap selesaikan pembayaran terutang sebelum mengubah langganan"
    },
    "step_3": {
      "finish_button": "SELESAI",
      "subscribe_successful": "Berlangganan berhasil!",
      "thanks": "Terima kasih telah memberi kami kesempatan untuk membantu kamu tumbuh lebih jauh dan lebih besar.",
      "thanks_2": "Mari kita lakukan ini bersama."
    },
    "step_4": {
      "payment_failed": "Pembayaran gagal",
      "retry_button": "Coba lagi Pembayaran",
      "try_again": "Pembayaran tidak berhasil, harap coba lagi."
    },
    "connect_subscription": "Berlangganan Connect"
  }
}
</i18n>
